import { render } from "./sign.vue?vue&type=template&id=409dddf1&scoped=true"
import script from "./sign.vue?vue&type=script&lang=js"
export * from "./sign.vue?vue&type=script&lang=js"

import "./sign.vue?vue&type=style&index=0&id=409dddf1&lang=less&scoped=true"

import exportComponent from "D:\\workstudio\\website67\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409dddf1"]])

export default __exports__